// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react'
import Store from './Store'
import constantsStore from './constantsStore'
import PropTypes from 'prop-types'

class StoreContainer extends Component {
  render () {
    const { match: { params: { company, store } } } = this.props
    return <Store {...constantsStore} company={company} store={store} />
  }
}

StoreContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      company: PropTypes.string.isRequired,
      store: PropTypes.string.isRequired
    })
  })
}

export default (StoreContainer)



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Store/StoreContainer.js